import { throttle } from 'lodash-es';

export default (app) => {
  window.addEventListener('scroll', throttle(() => app.emit('window:scroll'), 100));
  window.addEventListener('resize', throttle(() => app.emit('window:resize'), 100));
  window.addEventListener('click', (event) => app.emit('window:click', { clickEvent: event }));
};
